module.exports = new __parcel__URL__("seedling.562f3bc0.svg").toString();